import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { useSelector, useDispatch } from "react-redux";

//Components
import Table from 'Modules/manufacturers/.components/deviceModelsTab/.components/bulkAssignAlertTypes/.components/tableAlertTypes';
import { Modal, ModalBody, ModalFooter, Button } from "@gpstrackit/react-controls";
import { NotificationManager } from 'Components/Notifications';
import CustomSelect from 'Components/Select';
import { Grid } from "@mui/material";

//Actions
import { getDeviceModels } from 'Modules/alertTypes/views/main/.components/alertTypeDetails/redux/saga';
import { searchEntityRequest, clearRedux, bulkAssignAlertTypesRequest } from 'Redux/actions';

//Styles
import './index.scss'

const BulkAssignAlertTypes = (props) => {
    const { messages } = useIntl();
    const dispatch = useDispatch();

    //Local States
    const [selected, setSelected] = useState([])
    const [devicesModel, setDeviceModel] = useState(null);
    const [parents, setParents] = useState([]);

    //Redux States
    const alertTypes = useSelector(state => state.generalRedux.alertTypes);
    const { openModal, loading, devicesModels, result } = useSelector(state => state.bulkAssignAlertTypesRedux)

    const closeModal = () => {
        setSelected([])
        setDeviceModel(null)
        dispatch(clearRedux("BULK_ASSIGN_ALERT_TYPES"))
    }

    const applyAlertTypes = () => {
        let parentsValidate = devicesModel.deviceModelAlertTypes.filter((item) => item.alertType?.parentId).map((item) => item.alertType?.parentId)
        parentsValidate = parentsValidate.filter((value, index) => parentsValidate.indexOf(value) === index);

        let ids = devicesModel?.deviceModelAlertTypes?.length ? devicesModel?.deviceModelAlertTypes?.map((item) => (item.alertTypeId)) : []
        if (ids.length) setSelected(ids)

        if (parentsValidate.length) {
            parentsValidate.forEach(item => {
                if (!ids.includes(item)) ids.push(item)
            });
        } else {
            NotificationManager.warning(
                messages['bulk_assg_altype_warning_message'],
                messages['bulk_assg_altype_title'],
                3000
            );
        }
    }

    const applyChanges = () => {
        let payload = {
            devicesModels,
            alertTypes: selected
        }
        dispatch(bulkAssignAlertTypesRequest(payload))
    }

    const insertDeviceModel = (item) => {
        setDeviceModel(item)
    }

    const removeDuplicates = (arr) => {
        let unique = {};
        let result = [];
        for (let i = 0; i < arr.length; i++) {
            if (!unique[arr[i].id]) {
                result.push(arr[i]);
                unique[arr[i].id] = true;
            }
        }
        return result;
    }

    const getDeviceModelsForSelect = (input, callback) => {
        if (!input) {
            callback([])
            return
        }
        getDeviceModels(input).then((response) => {
            if (response.result) {
                const { items } = response?.result
                let list = removeDuplicates(items)
                callback(list)
            }
        })
    }

    useEffect(() => {
        if (result) {
            if (result?.error) {
                NotificationManager.error(
                    messages['bulk_assg_altype_error_message'],
                    messages['bulk_assg_altype_title'],
                    3000
                );
                dispatch(clearRedux("BULK_ASSIGN_ALERT_TYPES", { result: null }))
            } else {
                NotificationManager.success(
                    messages['bulk_assg_altype_success_message'],
                    messages['bulk_assg_altype_title'],
                    3000
                );
                closeModal()
            }
        }
    }, [result])

    useEffect(() => {
        openModal && dispatch(searchEntityRequest({ key: "alertTypes" }));
    }, [openModal])

    useEffect(() => {
        if (alertTypes && alertTypes.length) {
            let newParents = alertTypes.filter((item) => item?.parentId).map((item) => (item.parentId))
            newParents = newParents.filter((value, index) => newParents.indexOf(value) === index);
            setParents(newParents)
        }
    }, [alertTypes])

    return (
        <Modal
            open={openModal}
            title={messages['bulk_assg_altype_title']}
            handleClose={() => closeModal()}
            position="right"
            loading={loading}
            size="small"
        >
            <ModalBody className="edit-alert-type">
                <div style={{ marginBottom: 10, padding: '0 0 0 10px' }}>
                    <Grid
                        container
                        alignItems="center"
                        justifyContent="space-between"
                        spacing={2}
                    >
                        <Grid item xs={10}>
                            <CustomSelect
                                async
                                value={devicesModel}
                                onChange={(items) => insertDeviceModel(items)}
                                label={messages['bulk_assg_altype_from_device_model']}
                                loadOptions={getDeviceModelsForSelect}
                                loading={false}
                                required
                                getOptionLabel={e => `${e.name} (${e.manufacturer?.name})`}
                                getOptionValue={e => e.id}
                                placeholder={messages['alert_details_placeholder']}
                            />
                        </Grid>
                        <Grid item xs={2} style={{ marginTop: 24 }}>
                            <Button
                                className="btn-dark-blue add-button"
                                disabled={!devicesModel}
                                onClick={(e) => {
                                    e.preventDefault();
                                    applyAlertTypes()
                                }}
                            >
                                {messages['bulk_assg_altype_add']}
                            </Button>
                        </Grid>
                    </Grid>
                </div>
                <Table
                    alertTypes={alertTypes}
                    setSelected={setSelected}
                    selected={selected}
                    parents={parents}
                />
            </ModalBody>
            <ModalFooter>
                <Button
                    className="btn-cancel"
                    onClick={() => closeModal()}
                >
                    {messages['cancel']}
                </Button>
                <Button
                    className="btn-dark-blue"
                    onClick={() => applyChanges()}
                    disabled={selected?.length === 0 || loading}
                >
                    {messages['save']}
                </Button>
            </ModalFooter>
        </Modal>
    )
}


export default BulkAssignAlertTypes;